// extracted by mini-css-extract-plugin
export const wrapper = "WaterHarvesting-module--wrapper--bIKFf";
export const rain = "WaterHarvesting-module--rain--2TkPc";